export const borderRadius = {
  '2': '2px',
  '4': '4px',
  '8': '8px',
  '16': '16px',
  '100': '100%',
};
